import React from 'react';
import DropDown from 'Components/DropDown';
import { ContainerDropdown } from './style';

export default function DropDowns({ titles = [], options = [], methods = [] }) {
  return (
    <ContainerDropdown>
      {titles.map((title, index) => {
        const id = title + index;
        return <DropDown key={id} title={title} options={options[index]} setData={methods[index]} />;
      })}
    </ContainerDropdown>
  );
}
